import React, { useMemo } from 'react'
import { useNavigate } from 'react-router-dom'
import { Box, Button, Alert, LinearProgress } from '@mui/material'
import RateReviewOutlinedIcon from '@mui/icons-material/RateReviewOutlined'
import PageTitle from '../../../components/PageTitle'
import { KpiRow, Pill, SectionCard, ActionIconBtn } from '../components/common'
import DataTable from '../components/Tables'
import { PATHS } from '../constants'
import { useListAllProposalsQuery } from '../../../redux/d2cApiSlice'
import { proposalRow, inGroup, computeKpis } from '../apiMap'

export default function FHDashboard() {
  const navigate = useNavigate()
  const { data, isLoading, isError, error } = useListAllProposalsQuery({ page: 0, size: 100 })
  const rows = useMemo(() => {
    const mapped = Array.isArray(data) ? data.map(proposalRow).filter((r) => inGroup('fhQueue', r.apiStatus)) : []
    return [...mapped].sort((a, b) => new Date(b.raw?.updatedAt || 0) - new Date(a.raw?.updatedAt || 0)) // most recently changed first
  }, [data])
  const kpis = useMemo(() => computeKpis(data, 'fh'), [data])

  const openReview = (r) => navigate(PATHS.fhReview, { state: { proposalId: r.proposalId, versionId: r.versionId, brand: r.brand, card: r.card, orderDataFileUri: r.orderDataFileUri, status: r.apiStatus } })
  const columns = [
    { key: 'brand', label: 'Brand', render: (r) => <b>{r.brand}</b> },
    { key: 'from', label: 'From' },
    { key: 'why', label: 'Why', render: (r) => <Pill label={r.why} styleKey={r.whyKey} /> },
    { key: 'waiting', label: 'Waiting', align: 'right' },
    { key: 'sent', label: 'Last updated', align: 'right' },
    { key: 'a', label: 'Action', align: 'right', render: (r) => <ActionIconBtn title="Review" onClick={() => openReview(r)}><RateReviewOutlinedIcon fontSize="small" /></ActionIconBtn> },
  ]
  return (
    <Box sx={{ px: 3 }}>
      <PageTitle>D2C Pricing · Functional Head Dashboard</PageTitle>
      <KpiRow items={kpis} />
      {isLoading && <LinearProgress sx={{ my: 1 }} />}
      {isError && <Alert severity="error" sx={{ my: 1 }}>{error?.message || 'Failed to load proposals.'}</Alert>}
      <SectionCard
        title="Needs your sign-off"
        subtitle="Pricing-authored changes, below-10% rebuilds and escalations. Open the queue for the full list."
        action={<Button variant="contained" sx={{ textTransform: 'none', borderRadius: '6px' }} onClick={() => navigate(PATHS.fhQueue)}>Open Approval Queue →</Button>}
      >
        <DataTable columns={columns} rows={rows} getRowKey={(r) => r.id} emptyText={isLoading ? 'Loading…' : 'Nothing needs your sign-off'} />
      </SectionCard>
    </Box>
  )
}
